<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            Wyślij powiadomienie
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-form ref="doctor-send">
                  <v-select
                    v-model="type"
                    :items="typeList"
                    color="blue-grey lighten-2"
                    label="Typ"
                    item-text="label"
                    return-object
                  ></v-select>
                  <v-text-field
                    v-model="title"
                    label="Tytuł"
                    name="title"
                  ></v-text-field>
                  <v-text-field
                    v-model="notification"
                    label="Notyfikacja"
                    name="notification"
                  ></v-text-field>

                  <v-select
                    v-if="type && type.id === 3 && moviesList"
                    v-model="data"
                    :items="moviesList"
                    color="blue-grey lighten-2"
                    :label="type.label"
                    item-value="id"
                    item-text="title"
                  ></v-select>
                  <v-select
                    v-if="type && type.id === 4 && calendarList"
                    v-model="data"
                    :items="calendarList"
                    color="blue-grey lighten-2"
                    :label="type.label"
                    item-value="id"
                    item-text="title"
                  ></v-select>
                  <v-text-field
                    v-if="type && type.id === 2"
                    v-model="data"
                    label="Url"
                    name="url"
                  ></v-text-field>

                  <v-select
                      v-model="target"
                      :items="targetList"
                      color="blue-grey lighten-2"
                      label="Zgody"
                      item-text="label"
                      return-object
                  ></v-select>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error darken-1" @click="close()">
            Zamknij
          </v-btn>
          <v-btn color="success darken-1" @click="sendNotify()">
            <v-icon class="mr-4">mdi-email-send-outline</v-icon>
            Wyślij
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import axiosConf from "../axios-conf";

export default {
  mixins: [validationMixin],
  name: "DoctorSendNotify",
  props: {
    open: Boolean
  },
  data() {
    return {
      dialog: false,
      typeList: [
        { slug: "url", label: "Url", id: 2 },
        { slug: "notify", label: "Notyfikacja", id: 1 }
      ],
      targetList: [
        { slug: "SYSTEM", label: "Zgoda systemowa" },
        { slug: "MARKETING", label: "Zgoda marketingowa" }
      ],
      validUrl: [value => this.isURL(value) || "URL is not valid"],
      moviesList: [],
      calendarList: [],
      interestsList: [],
      title: "",
      notification: "",
      target: null,
      data: "",
      type: null,
      errors: {
        title: [],
        notification: [],
        data: [],
        type: []
      }
    };
  },
  methods: {
    isURL(str) {
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
    close() {
      this.dialog = false;
      this.$emit("close", "close");
    },
    sendNotify() {
      if (!this.type) {
        return;
      }
      axiosConf
        .post(
          "patient/mobile-push.json",
          {
            title: this.title,
            notification: this.notification,
            data: this.data,
            type: this.type.id,
            target: this.target.slug
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("loggedIn")}`
            }
          }
        )
        .then(() => {
          this.close();
        });
    },
    setMoviesList(groups) {
      groups.forEach(group => {
        this.moviesList.push({
          header: group.name,
          type: "header"
        });
        group.movies.forEach(movie => {
          this.moviesList.push(movie);
        });
      });
    },
    setCalendarList(years) {
      years.forEach(year => {
        this.calendarList.push({
          header: year.year,
          type: "header"
        });
        year.items.forEach(item => {
          this.calendarList.push(item);
        });
      });
    }
  },
  watch: {
    open(newVal) {
      this.dialog = newVal;
    },
    type() {
      this.data = null;
      this.moviesList = [];
      this.calendarList = [];
    }
  }
};
</script>
